/**
 * 公共请求
 */

import {POST,GET} from './service.config.js'
import md5 from 'js-md5'

/**
 * 获取验证码
 * @param tel 手机号
 * @param type
 * @returns {*|Promise|Promise<unknown>}
 */
export const getCodeService = (tel,type) => POST('btrexchange/sendYzm',{
    tel,
    status:type,
});


/**
 * 获取咨询内容
 * @returns {*|Promise|Promise<unknown>}
 */
export const getConsultationServive = () => GET('btrbasic/consultation');

/**
 * 获取咨询详情
 * @param id 咨询编号
 * @returns {*|Promise|Promise<unknown>}
 */
export const getConsultationDetailsServive = id => POST('btrbasic/getconsultationInfo',{id});

/**
 * 获取公司简介
 * @returns {*|Promise|Promise<unknown>}
 */
export const getCompanyProfileService = () => GET('btrbasic/companyProfile');

/**
 * 更具经纬度解析出详细地址
 * @param lat
 * @param lng
 * @returns {*|Promise|Promise<unknown>}
 */
export const getAddressService = (lat,lng) => POST('btrexchange/jwInfoAddress',{
    lat,
    lng,
});


/**
 * 支付宝提现
 * @param account 支付宝账号
 * @param name 支付宝真是姓名
 * @param price 提现金额
 * @param id 用户ID
 * @param password 提现密码
 * @param level 用户身份 0用户，1合伙人，2商家
 * @returns {*|Promise|Promise<unknown>}
 */
export const alipayCashService = (account,name,price,id,password,level) => POST('btrexchange/zfb_tx',{
    amount:price,
    payee_account:account,
    payee_real_name:name,
    id:id,
    level:level,
    password:md5(password),
});


/**
 * 获取城市信息
 * @param pid
 * @returns {Promise | Promise<unknown>}
 */
export const getAddressListSerivce =  (pid = 0) => POST('btractivityshare/getAreas',{
    pid,
});


export const getVisitsnumService = () => GET('btrbasic/getVisitsnum');


/**
 * 获取新闻列表
 * @param {*} page 
 * @param {*} limit 
 */
export const getNewsListService = (page,limit) => POST('btrbasic/getNews',{
    page,
    limit,
});


/**
 * 获取新闻详情
 * @param {*} id 
 */
export const getNewsDetailsService = id => POST('btrbasic/getNewsDetail',{
    id,
});


export const getNowsServive = id => POST('btrbasic/getNoticeDetail',{id});